import Model from '../models/model'
import consts from '../consts';

const itemLogColumns = [
	{ field: 'SerialNumber', headerName: "SerialNumberSecond", width: 150 },
	{ field: 'Barcodes', headerName: "Barcode", width: 150 },
	{ field: 'RFID', headerName: "RFID", width: 150 },
	{ field: 'HookupValue', headerName: 'Hookup', width: 150 },
	{ field: 'status', headerName: "Status", width: 300 },
];

const model = new Model({
	name: 'EndoSetupHookupRapidAER',
	disableDelete: true,
	disableAdd: true,
	idProperty: '_id',
	pageSize: 5,
	showGridRefreshBtn: true,
	gridRefreshInterval: 150000, //Long polling ms
	defaultSort: 'MachineModel ASC',
	allowImport: true,
	importProps: { message: "ScopesCountWarning", maxCount: consts.maxScopesCount, logColumns: itemLogColumns, fileType: consts.endoImportSpec.Hookups.fileType, type: consts.endoImportSpec.Hookups.type },
	columns: [
		{ header: 'EquipmentModel', field: 'MachineModel', width: 150 },
		{ header: 'HookupBlock', field: 'HookupValue', width: 120 },
		{ header: 'InventoryCount', field: 'InventoryCount', align: 'right', type: 'number', headerAlign: 'right', width: 120 },
		{ header: 'Channels', field: 'Channels', width: 140, align: 'right', headerAlign: 'right' },
		{ header: 'LeakTestChannels', field: 'ChannelsLeakTest', width: 150, align: 'right', headerAlign: 'right', type: 'number' }
	]
});

export const RapidAERHookupModel = model;
export default model.createFormBase();
